// import { useEffect, useState } from "react";
// import { getDecryptedData } from "../../config/crypto";
// import { IMAGE_URL, REACT_APP_API_PORT } from "../../Api";
// import { FaPlay } from "react-icons/fa";
// import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
// import "react-circular-progressbar/dist/styles.css";
// import axios from "axios";
// import Loader from "../Loader";
// import { useNavigate } from "react-router";
// const MyCourses = () => {
//     const navigate = useNavigate()
//     const [apiIsLoading, setapiIsLoading] = useState(false)
//     const [data, setData] = useState([])
//     const progress = 20;
//     useEffect(() => {
//         const getData = async () => {
//             try {
//                 setapiIsLoading(true);
//                 const token = getDecryptedData("token");
//                 const res = await axios.get(`${REACT_APP_API_PORT}user/course/order/course-list`, {
//                     headers: {
//                         "Content-Type": "application/json",
//                         "x-access-token": token,
//                     },
//                 });
//                 setapiIsLoading(false);
//                 if (res.data.status) {
//                     setData(res.data.data);
//                 }
//             } catch (err) {
//                 setapiIsLoading(false);
//                 console.log(err);
//             }
//         };
//         getData();
//     }, []);


//     return <>
//         <Loader isLoading={apiIsLoading} />
//         <div className="grid grid-cols-1 lg:grid-cols-3 my-4 gap-4">

//             {
//                 (data && data?.length > 0) &&
//                 data?.map((item, index) => {
//                     return <>
//                         <div className="max-w-sm blurBox bg-gray-900  rounded-lg shadow-xl overflow-hidden relative">
//                             <div className="relative">
//                                 <img className="w-full h-48 object-fit:cover" src={item?.banner ? IMAGE_URL + item?.banner : "/images/placeholder-image.png"} alt="" />

//                                 <div className="absolute bottom-[-20px] left-1/2 transform -translate-x-1/2 w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-md overflow-hidden border border-gray-300">
//                                     <div className="w-14 h-14">
//                                         <CircularProgressbar
//                                             value={item?.completionPercentage}
//                                             text={`${item?.completionPercentage}%`}
//                                             styles={buildStyles({
//                                                 pathColor: progress > 50 ? "#3ff74a" : "black",
//                                                 trailColor: "#e5e7eb",
//                                                 textSize: "20px",
//                                                 textColor: "purple",
//                                                 strokeLinecap: "round",
//                                                 backgroundColor: "white",
//                                             })}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="p-4 flex justify-center">
//                                 <div className="my-3">
//                                     <span className="text-2xl font-semibold text-white">
//                                         {item?.course_name}
//                                     </span>
//                                 </div>
//                             </div>

//                             <div className="h-1 border-t border-gray-300"></div>

//                             <div className="flex justify-center mb-3">
//                                 <button
//                                  onClick={()=>{
//                                     navigate(`/user-course-dashboard/${item?._id}`)
//                                  }}
//                                  className="flex items-center mt-4 px-4 py-2 border border-black text-white bg-[#0068ff] rounded-lg hover:opacity-90 transition ">
//                                     Start Course <FaPlay className="mx-1" />
//                                 </button>
//                             </div>
//                         </div>

//                     </>
//                 })

//             }

//             {/* <div className="max-w-sm blurBox bg-gray-900  rounded-lg shadow-xl overflow-hidden relative">
//           <div className="relative">
//             <img className="w-full h-48 object-cover" src="https://picsum.photos/200" alt="" />

//             <div className="absolute bottom-[-20px] left-1/2 transform -translate-x-1/2 w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-md overflow-hidden border border-gray-300">
//               <div className="w-14 h-14">
//                 <CircularProgressbar
//                   value={progress}
//                   text={`${progress}%`}
//                   styles={buildStyles({
//                     pathColor: progress > 50 ? "#3ff74a" : "black",
//                     trailColor: "#e5e7eb",
//                     textSize: "20px",
//                     textColor: "purple",
//                     strokeLinecap: "round",
//                     backgroundColor: "white",
//                   })}
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="p-4 flex justify-center">
//             <div className="my-3">
//               <span className="text-2xl font-semibold text-white">
//                 AI Tools At Work Course
//               </span>
//             </div>
//           </div>

//           <div className="h-1 border-t border-gray-300"></div>

//           <div className="flex justify-center mb-3">
//             <button className="flex items-center mt-4 px-4 py-2 border border-black text-white bg-[#0068ff] rounded-lg hover:opacity-90 transition ">
//               Start Course <FaPlay className="mx-1" />
//             </button>
//           </div>
//         </div> */}


//         </div>
//     </>
// };

// export default MyCourses



import { useEffect, useState } from "react";
import { getDecryptedData } from "../../config/crypto";
import { IMAGE_URL, REACT_APP_API_PORT } from "../../Api";
import { FaPlay } from "react-icons/fa";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import axios from "axios";
import Loader from "../Loader";
import { useNavigate } from "react-router";

const MyCourses = () => {
    const navigate = useNavigate();
    const [apiIsLoading, setApiIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 3; // Set the number of courses per page

    useEffect(() => {
        const getData = async () => {
            try {
                setApiIsLoading(true);
                const token = getDecryptedData("token");

                const res = await axios.get(
                    `${REACT_APP_API_PORT}user/course/order/course-list?page=${page}&limit=${limit}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    }
                );

                setApiIsLoading(false);

                if (res.data.status) {
                    setData(res.data.data);
                    setTotalPages(res.data.pagination?.totalPages || 1);
                }
            } catch (err) {
                setApiIsLoading(false);
                console.log(err);
            }
        };
        getData();
    }, [page]); // Fetch data when `page` changes

    return (
        <>
            <Loader isLoading={apiIsLoading} />

            <div className="grid grid-cols-1 lg:grid-cols-3 my-4 gap-4">
                {data && data.length > 0 ? (
                    data.map((item, index) => (
                        <div key={index} className="max-w-sm blurBox bg-gray-900 rounded-lg shadow-xl overflow-hidden relative">
                            <div className="relative">
                                <img
                                    className="w-full h-48 object-cover"
                                    src={item?.banner ? IMAGE_URL + item?.banner : "/images/placeholder-image.png"}
                                    alt=""
                                />
                                <div className="absolute bottom-[-20px] left-1/2 transform -translate-x-1/2 w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-md overflow-hidden border border-gray-300">
                                    <div className="w-14 h-14">
                                        <CircularProgressbar
                                            value={item?.completionPercentage}
                                            text={`${item?.completionPercentage}%`}
                                            styles={buildStyles({
                                                pathColor: item?.completionPercentage > 50 ? "#3ff74a" : "black",
                                                trailColor: "#e5e7eb",
                                                textSize: "20px",
                                                textColor: "purple",
                                                strokeLinecap: "round",
                                                backgroundColor: "white",
                                            })}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="p-4 flex justify-center">
                                <div className="my-3">
                                    <span className="text-2xl font-semibold text-white">{item?.course_name}</span>
                                </div>
                            </div>

                            <div className="h-1 border-t border-gray-300"></div>

                            <div className="flex justify-center mb-3">
                                <button
                                    onClick={() => navigate(`/user-course-dashboard/${item?._id}`)}
                                    className="flex items-center mt-4 px-4 py-2 border border-black text-white bg-[#0068ff] rounded-lg hover:opacity-90 transition"
                                >
                                    Start Course <FaPlay className="mx-1" />
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-white text-start col-span-3">No courses found.</p>
                )}
            </div>

            {/* Pagination Controls */}
            {
                (page !== totalPages) && <>
                    <div className="flex justify-center items-center mt-6">
                        <button
                            disabled={page === 1}
                            onClick={() => setPage(page - 1)}
                            className={`px-4 py-2 mx-1 border rounded-lg ${page === 1 ? "bg-gray-500 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}`}
                        >
                            Previous
                        </button>
                        <span className="text-white mx-2">
                            Page {page} of {totalPages}
                        </span>
                        <button
                            disabled={page === totalPages}
                            onClick={() => setPage(page + 1)}
                            className={`px-4 py-2 mx-1 border rounded-lg ${page === totalPages ? "bg-gray-500 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}`}
                        >
                            Next
                        </button>
                    </div>
                </>
            }

        </>
    );
};

export default MyCourses;
